import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { Heart } from 'lucide-react';

export default function SponsorLoyaltyBadge() {
  const [loyalty, setLoyalty] = useState([]);
  const [bonus, setBonus] = useState(0.02);

  useEffect(() => {
    api.get('/sponsorships/loyalty/mine').then(r => {
      setLoyalty(r.data.loyalty || []);
      setBonus(r.data.bonus || 0.02);
    }).catch(() => {});
  }, []);

  if (loyalty.length === 0) return null;

  return (
    <div className="mt-4 border border-[#B26BFF]/40 bg-[#B26BFF]/8 p-3 flex items-center gap-3" data-testid="loyalty-badge">
      <div className="w-9 h-9 rounded-full bg-[#B26BFF]/20 border border-[#B26BFF]/50 grid place-items-center flex-shrink-0">
        <Heart className="w-4 h-4 text-[#B26BFF]" fill="#B26BFF" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-white text-sm font-semibold">
          Sponsor loyalty active · <span className="text-[#B26BFF] font-mono">+{(bonus * 100).toFixed(0)}%</span> multiplier bonus
        </div>
        <div className="text-xs text-[#B7BDC6] mt-0.5 truncate">
          Earned by voting on verified sponsors: {loyalty.map(l => l.coin_symbol).join(', ')}
        </div>
      </div>
    </div>
  );
}
